module.exports = __webpack_public_path__ + "static/media/400084_01.4a734d24.png";